export default [
  {
    header: 'Studypress',
  },
  {
    title: 'Updates',
    route: 'studypress_updates',
  },
  {
    title: 'Contact',
    route: 'studypress_contact',
  }, 
  // {
  //   title: 'Help',
  //   route: 'studypress_help',
  // }, 
]
